import Icon from "@ant-design/icons";
import React from "react";

export default function CorrelationIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.892 7.72384C9.32778 7.18451 7.52376 7.53156 6.26465 8.77114C4.49361 10.5147 4.47134 13.3639 6.21491 15.1349C7.45448 16.394 9.25286 16.7692 10.8254 16.2544C10.8178 16.2468 10.8102 16.2391 10.8026 16.2315C8.47788 13.8701 8.50758 10.0712 10.869 7.74643C10.8766 7.73888 10.8843 7.73135 10.892 7.72384ZM12.2914 6.70685C10.0308 5.47508 7.14173 5.80272 5.21231 7.70222C2.85093 10.027 2.82123 13.8259 5.14599 16.1872C7.04548 18.1167 9.9291 18.4894 12.2086 17.2931C14.4692 18.5249 17.3582 18.1973 19.2877 16.2978C21.6491 13.973 21.6788 10.1741 19.354 7.81276C17.4545 5.88333 14.5709 5.51056 12.2914 6.70685ZM12.2774 8.49963C12.1546 8.59751 12.0357 8.70275 11.9213 8.81535C10.1503 10.5589 10.128 13.4081 11.8716 15.1791C11.9842 15.2935 12.1014 15.4006 12.2226 15.5004C12.3454 15.4025 12.4643 15.2973 12.5787 15.1846C14.3497 13.4411 14.372 10.5919 12.6284 8.82088C12.5158 8.7065 12.3986 8.59941 12.2774 8.49963ZM13.6079 16.2762C13.6156 16.2687 13.6233 16.2611 13.631 16.2536C15.9924 13.9288 16.0221 10.1299 13.6973 7.76854C13.6898 7.76087 13.6822 7.75322 13.6746 7.74559C15.2471 7.23077 17.0455 7.60598 18.2851 8.86509C20.0286 10.6361 20.0064 13.4853 18.2353 15.2289C16.9762 16.4684 15.1722 16.8155 13.6079 16.2762Z"
        fill="#344054"
      />
    </svg>
  );
};
